// extracted by mini-css-extract-plugin
export default {"mainContent":"AddProduct_mainContent__97k1O","placeHolderShimmer":"AddProduct_placeHolderShimmer__7aKWV"};